<template>
  <el-select :disabled="disabled" filterable v-model="useModel" :clearable="clearable" placeholder="Select" v-loading="isLoading" @change="emitChanged">
    <el-option v-for="status in statusList" :value="status.id" :label="status.description" :key="status.id">
    </el-option>
  </el-select>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  props: {
    inputModel: {
      default: 0
    },
    clearable: {
      default: false
    },
    disabled: {
      default: false
    },
    statusAllowed: null
  },
  data () {
    return {
      statusList: Array,
      isLoading: true
    }
  },
  computed: {
    useModel: {
      get: function () {
        return this.inputModel
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  },
  methods: {
    fetchStatusList () {
      this.isLoading = true
      if (sessionStorage.getItem('statusList')) {
        this.statusList = JSON.parse(sessionStorage.getItem('statusList'))
        this.isLoading = false
        if (this.statusAllowed) {
          this.modifyStatusList()
        }
      } else {
        var call = '/getPEAStatusList'
        this.$axios.get(call).then(response => {
          const unsortedList = response.data
          const sortedList = unsortedList.sort((a, b) => (a.description.toLowerCase() > b.description.toLowerCase()) ? 1 : -1)
          this.statusList = sortedList
          sessionStorage.setItem('statusList', JSON.stringify(this.statusList))
          this.isLoading = false
          if (this.statusAllowed) {
            this.modifyStatusList()
          }
        }).catch(reject => {
          this.isLoading = false
          if (this.$route.name === 'Custom Grouping Reports') {
            helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Status List', reject.body, 'error', 30000, '')
          } else if (this.$route.name === 'advancedSearch') {
            helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Status List', reject.body, 'error', 30000, '')
          }
        })
      }
    },
    emitChanged () {
      this.$emit('changed')
    },
    modifyStatusList () {
      var filteredList = []
      this.statusList.forEach((status, index) => {
        if (this.statusAllowed.includes(status.description) || status.id === this.useModel) {
          filteredList.push(status)
        }
      })
      this.statusList = filteredList
    }
  },
  created () {
    this.fetchStatusList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
